import { render, staticRenderFns } from "./Honoraires.vue?vue&type=template&id=2c6c58b0"
import script from "./Honoraires.vue?vue&type=script&lang=ts"
export * from "./Honoraires.vue?vue&type=script&lang=ts"
import style0 from "./Honoraires.vue?vue&type=style&index=0&id=2c6c58b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports